import rph from './rph.js'

const settings = {
	debug: 0,
	imVolume: 0.70,
	pingVolume: 0.70,
	favUsers: [],
	maxHistory: 500,
	sortTabs: true,
	fontSize: 0.9875,
	font: 'Calibri',
	fontWeight: 400,
	notifyWords: 'Donate to RPH',
	notifyWordsi: false,
	pmPosition: {
		top: window.innerHeight / 2 - 240,
		left: window.innerWidth / 2 - 300
	},
	pmSize: {
		width: 600,
		height: 480
	},
	pms: [],
	theme: Math.round( Math.random() ) ? 'Dark' : 'Medium',
	customTheme: '',
	msgDivider: true,
	notes: {},
	set: function( key, value ){
		if( !key ){
			return false
		}
		// eslint-disable-next-line eqeqeq
		if( typeof value !== 'object' && parseInt( value ) == value ){
			value = parseInt( value )
		}
		this[key] = value
		this.save()
		rph.handleSetting( key, value )

		if( process && process.env.IS_ELECTRON ){
			console.log( 'process.type in settings.js', process.type )
			//proxy settings and handle IPC
			if( !process.type ){ // no env is renderer
				window.ipc.send( 'settingsOperation', key, value )
			}
		}
		//no process is browser
	},
	save: function(){
		if( this.accid ){
			localStorage[this.accid + '-settings'] = JSON.stringify( this )
		}
	}
}
// Object.keys(settings).forEach()

if( process && process.type === 'browser' ){
	/*ipcMain.on( 'settingsOperation', ( e, key, value ) => {
		console.log( 'do settings operation...', key, value )
	})*/
}

export default settings
